export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -78 });
  } else if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
